// 功能：菜单待办红点
export default {
  created() {
    this.getServiceTodo()
    this.getKpiTodo()

    const _this = this
    const callback = function(event) {
      const { source, value } = event.data || {}
      if (source === 'PolarisBadge') {
        _this.badge = {
          ..._this.badge,
          ...value,
        }
      }
    }
    window.addEventListener('message', callback)
    this.$once('hook:beforeDestroy', function() {
      window.removeEventListener('message', callback)
    })
  },

  data() {
    return {
      // 二级、三级需展示待办红点的路由，需与routes.js中path保持一致
      badge: {
        'evaluation-list': false, // 服务中心-服务质量评价
        kpi: false,
      },
    }
  },

  methods: {
    // 服务中心待办事项
    getServiceTodo() {
      this.fetch
        .get('getServiceTodo')
        .then(res => {
          this.badge['evaluation-list'] = !!res.data
          window.postMessage({
            source: 'AssociateBadge',
            value: this.badge,
          })
        })
        .catch(() => {})
    },
    // 绩效提报单待确认事项
    getKpiTodo() {
      this.fetch
        .post('getKpiTodo', {
          businessLine: 2,
          status: 3,
          pageNo: 1,
          pageSize: 99999,
        })
        .then(res => {
          this.badge.kpi = !!res.totalCount
          window.postMessage({
            source: 'AssociateBadge',
            value: this.badge,
          })
        })
    },

    // 父级菜单是否展示红点
    isParentShowBadge(route) {
      const children = route.children || []
      if (!children.length) return this.isShowBadge(route.path)

      return children.some(item => {
        const subChildren = item.children || []
        if (!subChildren.length) return this.isShowBadge(item.path)

        return subChildren.some(subItem => {
          return this.isShowBadge(subItem.path)
        })
      })
    },

    // 根据path判断是否展示红点
    isShowBadge(path) {
      return path ? this.badge[path] : false
    },
  },
}
